<template>
  <div v-on:keyup.enter="submit">
    <v-layout
      align-start
      justify-center
      fill-height
      :class="{'py-2': $vuetify.breakpoint.xs, 'py-5': $vuetify.breakpoint.smAndUp}"
    >
      <v-flex xs12 sm6 xl4>
        <v-card class="rounded-card elevation-0">
          <v-container>
            <v-flex xs10 offset-xs1 sm8 offset-sm2>
              <v-card-text class="text-center">
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-container>
                    <v-row>
                      <v-col cols="12" class="ma-2">
                        <v-text-field
                          v-model="email"
                          label="Email"
                          prepend-icon="mdi-email-outline"
                          class="cmr-input"
                          :rules="emailRules"
                          required
                          outlined
                          hide-details
                          dense
                        />
                      </v-col>
                      <v-col cols="12" class="ma-2">
                        <v-text-field
                          v-model="password"
                          label="Password"
                          prepend-icon="mdi-lock-outline"
                          class="cmr-input"
                          :rules="passwordRules"
                          required
                          outlined
                          hide-details
                          dense
                          type="password"
                        />
                      </v-col>
                      <v-col cols="12" class="ma-2">
                        <v-text-field
                          v-model="companyCode"
                          label="Company Code"
                          prepend-icon="mdi-numeric"
                          class="cmr-input"
                          :rules="companyCodeRules"
                          required
                          outlined
                          hide-details
                          dense
                        />
                      </v-col>
                      <v-col cols="12" class="ma-2">
                        <div class="captcha-container" id="recaptcha-container" @verify="getRecaptchResponse"></div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
                <v-divider></v-divider>
              </v-card-text>
            </v-flex>
            <v-layout align-start justify-center>
              <v-btn
                color="primary"
                id="signin"
                class="rounded-button text-none"
                :disabled="!valid"
                @click="submit"
              >
                <div v-if="!loading">Sign In</div>
                <pulse-loader v-else :loading="loading" color="#fff"></pulse-loader>
              </v-btn>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" max-width="450">
      <v-card>
        <v-card-title class="headline">
          Cannot sign in
          <v-icon v-if="error && !recaptchaResponse" class="ma-2">mdi-robot-angry</v-icon>
        </v-card-title>
        <v-card-text>
          {{this.error}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="text-center" text @click="dialog = false">Ok</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import router from '@/router'
export default {
  name: "SignInForm",
  components: {
    PulseLoader,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      recaptchaEnabled: false,
      recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      vueAppID: this.$store.state.appID,
      recaptchaResponse: '',
      loading: false,
      dialog: false,
      error: "",
      valid: false,
      email: "",
      password: "",
      companyCode: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      passwordRules: [(v) => !!v || "Password is required"],
      companyCodeRules: [(v) => !!v || "Company code is required"],
    };
  },
  mounted: function () {
    if (this.auth && !this.loggedout) {
      this.$router.push('/')
    }
    this.companyCode = localStorage.getItem("code");
      var self = this;
      if (this.recaptchaEnabled) {
        setTimeout(function () {
          grecaptcha.enterprise.render('recaptcha-container', {
            'sitekey' : process.env.VUE_APP_RECAPTCHA_SITE_KEY,
            'action': 'DISPATCH_LOGIN',
          });
        }, 1000);
      }
  },
  watch: {
    companyCode () {
    
    },
    auth () {
      if (this.auth && !this.loggedout) {
        this.$router.push('/')
      }
    }
  },
  methods: {
    captchaRendered () {
      const captchaElement = document.getElementById('recaptcha-container');
      return captchaElement && captchaElement.childNodes.length > 0;
    },
    renderCaptcha () {
      grecaptcha.enterprise.reset('recaptcha-container')
      grecaptcha.enterprise.render('recaptcha-container', {
        'sitekey' : process.env.VUE_APP_RECAPTCHA_SITE_KEY,
        'action': this.companyCode + '_dispatch_login',
      });
    },
    getRecaptchResponse () {
      var response = grecaptcha.enterprise.getResponse()
      this.recaptchaResponse = response
    },
    async submit() {
      if (this.$refs.form.validate()) {
        if (this.recaptchaEnabled) {
          this.getRecaptchResponse()
          if (!this.recaptchaResponse) {
            this.error = "Before we continue, we need to ensure that you're not a Robot trying to sneak in.";
            this.dialog = true
            return;
          }
        }
        this.loading = true;
        var codeError = await this.$store.dispatch("lookupCode", {
          code: this.companyCode,
        });

        if (codeError != null && codeError == "code_unknown") {
          this.loading = false;
          this.dialog = true;
          this.error = "Incorrect Company Code, please try again";
          return;
        } else if (codeError != null) {
          this.loading = false;
          this.dialog = true;
          this.error = "Network failure, Please check your internet connection";
          return;
        }

        this.$store.dispatch('login', {
          email: this.email,
          password: this.password,
          captchaToken: this.recaptchaResponse ,
          redirect: this.$route.query.redirect,
        }).then(error => {
          console.log('error', error);
          if (error != null && error == "auth_failed") {
            this.loading = false;
            this.dialog = true;
            this.error = "Incorrect Login Credentials, please try again";
          } else if(error != null) {
            this.loading = false;
            this.dialog = true;
            this.error = "Network failure, Please check your internet connection";
          } else if (!error) {
            this.$store.commit('setLoggedout', false)
            this.$store.dispatch('dispatch/getDispatchConfiguration')
            this.$store.dispatch('availabilityRegion/fetchCenter')
            if (this.$route.query.redirect != null) {
              return this.$router.push(this.$route.query.redirect);
            } else {
              return this.$router.push("/");
            }
          }
        })
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.rounded-button {
  border-radius: 8px !important;
}

#signin {
  border-radius: 12px !important;
  font-size: 18px;
  height: 48px;
  width: 120px;
}

#signup {
  border-radius: 12px !important;
  font-size: 14px;
}

.rounded-card {
  border-radius: 12px;
}

.captcha-container {
  display: flex;
  justify-content: center;
}
</style>
